import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Input,
    ViewChild,
    Renderer2,
    ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CodeName} from 'app/stocks/models/code-name';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {ISubscription} from "rxjs/Subscription";
import {SelectedFilter} from 'app/stocks/models/selected-filter';
import {ClearSelected} from 'app/stocks/models/clear-selected';
import {AdditionalFilterDataGUID} from "../../models/additional-filter-data";
import {StocksHelper} from "../../models/stocks-helper";
import {SelectedFilterGUID} from "../../models/selected-filter";
import {SelectedFilterOptions} from "../../models/selected-filter-options";

//type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'selected-filter',
    templateUrl: './selected-filter.component.html',
    styleUrls: ['./selected-filter.component.css']
})
export class SelectedFilterComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                private filterService: StocksFilterService){

        this.ordersSelectionModel = new Slick.RowSelectionModel<CodeName, Slick.Range[]>({selectActiveRow: false});
        this.gridView = new Slick.Data.DataView<CodeName>();

        this.columns = [
            {id: 'code', field: 'code', name: 'Code', sortable: true, width: 80},
            {id: 'name', field: 'name', name: 'Name', sortable: true, width: 235},
            {
                id: 'clear',
                field: 'Clear',
                name: '',
                sortable: false,
                width: 20,
                formatter: this.formatClearCell,
                asyncPostRender: this.renderClearCell
            },
        ];

        this.gridOptions = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true,
        };

        this.develop = false;
        this.messageTop = 0;
        this._showGrid = false;
        this.gridTop = -1000;
        this.slickScrollWidth = 8;
        this.showGridData = true;
        this.helper = new StocksHelper();
        this.setDefaultOptions();

        this.translates = {};
        this.commonData.translateService.get(['Remove']).subscribe(
            t =>{
                this.translates['Remove'] = t.Remove;
            });
    }

    @Input() mainData: SelectedFilter;
    @Input() GUID: string;
    @Input('options') optionsExt: SelectedFilterOptions;

    @ViewChild('grid')
    private grid: SlickGridComponent;

    @ViewChild('gridWrpEl')
    private gridWrpEl: ElementRef;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    //private filter: StocksFilter;

    public mouseDown: boolean;
    public readonly gridView: Slick.Data.DataView<CodeName>;
    public columns: Slick.Column<CodeName>[];
    public readonly gridOptions: Slick.GridOptions<CodeName>;
    private readonly ordersSelectionModel: Slick.RowSelectionModel<CodeName, Slick.Range[]>;
    private subscription: ISubscription;
    private develop: boolean;
    private subscriptionHideGrid: ISubscription;
    private subscriptionSelectedDataFilter: ISubscription;
    public wrpClass: any;
    private messageTop: number;
    public _showGrid: boolean;
    private readonly translates: { [key: string]: string };
    public gridTop: number;
    private slickScrollWidth: number;
    public showGridData: boolean;
    private helper: StocksHelper;
    public options: SelectedFilterOptions;
    private listenMouseDown: () => void;


    ngOnInit(){
        //# update filter
        //this.subscription = this.filterService.stocksFilterCurrent.subscribe(res => this.filter = res);
        if (this.optionsExt){
            this.setCurrentOptions(this.optionsExt)
        }

        if (this.options.closeGridAuto){
            this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e))
        }

        //# update data in filter
        this.subscriptionSelectedDataFilter = this.filterService.updateSelectedFiltersDataCurrent.subscribe((res: SelectedFilterGUID) => {
            this.helper.tryCatch(() => {
                if (res && res.GUID === this.GUID){
                    this.selectedFilters = res.selectedFilters
                }
            })
        });

        //# hide grid in this filter if it opens in another
        this.subscriptionHideGrid = this.filterService.hideFilterGridCurrent.subscribe((res: {GUID: string, param: string}) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.hideGrid = res.param : null)
        );

        this.wrpClass = this.generateWrpClass();
        this.columns = this.removeColumn(this.columns);
        this.selectedFilters = [this.mainData]
    }

    ngOnDestroy(){
        //this.subscription.unsubscribe();
        this.listenMouseDown && this.listenMouseDown();
        this.subscriptionSelectedDataFilter.unsubscribe();
        this.subscriptionHideGrid.unsubscribe();
    }

    ngAfterViewInit(){

        let timeout = setTimeout(() =>{
            clearTimeout(timeout);
            timeout = null;
        }, 10);

    }

    //# update data in filter
    set selectedFilters( filters: SelectedFilter[]){
        if (!filters){
            return;
        }

        if (this.mainData.data){
            let currentFilter = filters.find(f => f.name === this.mainData.name);
            if (!currentFilter){
                return;
            }
            if (this.mainData.type === 1 || this.mainData.type === 2 || this.mainData.type === 4){

                // console.log(currentFilter.data, 'selectedFilters')

                this.gridView.setItems([]);
                // console.log(this.mainData.data, 'this.mainData.data')
                this.gridView.setItems(currentFilter.data)
                this.mainData.selectedQuantity = currentFilter.selectedQuantity;
                this.mainData.allItemsQuantity = currentFilter.allItemsQuantity;
                this.mainData.dataString = currentFilter.dataString;
            }

            if (currentFilter.data.length < 2){
                this.showGridData = false;
            } else{
                this.showGridData = true;
            }
        }
    }

    public set hideGrid(param: string){
        if (this.mainData.name + 'selectedfilter' !== param){
            this.showGrid = false;
        }
    }

    public set showGrid(value: boolean){
        if (this._showGrid !== value){
            this._showGrid = value;
            if (value){
                this.filterService.setHideFilterGrid({ GUID: this.GUID, param: this.mainData.name + 'selectedfilter' });
            }
        }
    }

    public get showGrid(){
        return this._showGrid;
    }

    public setDefaultOptions = (): void => {
        this.options = {
            showCloseAllButton: true,
            closeGridAuto: false
        }
    }

    public setCurrentOptions = (options: SelectedFilterOptions): void => {
        if (!options){
            return;
        }

        for (let option in options){
            this.options[option] = options[option];
        }
    }

    //# toggle display grid
    public showGridOnClick = (): void =>{
        if (this.mainData.type === 1 || this.mainData.type === 2 || this.mainData.type === 4){
            if (!this.showGridData) return;
            this.showGrid = !this.showGrid;
            if (this.showGrid){
                this.filterService.setHideGridSelectedFilter({ GUID: this.GUID, show: false });
                this.showGrid = true;

                let timeout = setTimeout(() =>{
                    clearTimeout(timeout);
                    timeout = null;
                    this.columnWidth();
                }, 5);
                this.setGridTop();


                if (this.mainData.data.length === 0){
                    this.filterService.setLoadDataFilter({ GUID: this.GUID, param: this.mainData.name });
                }
            } else{
                this.gridTop = -1000;
            }
        }
    };

    //# remove data from filter
    public clearDataFilter = (data?: CodeName, e?: any) =>{
        if (this.develop) console.log(e, 'clearDataFilter');
        if (e) e.stopPropagation();
        let clearAll: boolean = !data;
        let clearFilter = new ClearSelected(this.mainData.name, clearAll);
        if (!clearAll){
            clearFilter.data = data;
        }

        if (this.develop) console.log(clearFilter, 'clearDataFilter 2');
        this.filterService.setClearSelectedFilter({ GUID: this.GUID, clearSelected: clearFilter });
    };

    //# generate class for mainwrp depends on filter type
    private generateWrpClass = (): any =>{
        let classes: any = {wrp: true};
        switch (this.mainData.type){
            case 1:
                classes['type-1'] = true;
                break;
            case 2:
                classes['type-2'] = true;
                break;
            case 3:
                classes['type-3'] = true;
                break;
            case 4:
                classes['type-4'] = true;
                break;
            case 5:
                classes['type-5'] = true;
                break;
        }
        return classes;
    };

    //# recalculate grid column width
    private columnWidth = (): void =>{
        let width = this.gridWrpEl.nativeElement.offsetWidth - 2;
        if (this.mainData.data.length > 4){
            width = width - this.slickScrollWidth;
        }
        this.columns.forEach(item =>{
            if (item.field !== 'name'){
                width = width - item.width;
            }
        });

        this.columns.forEach(item =>{
            if (item.field === 'name'){
                item.width = width;
            }
        });

        this.grid.resizeGrid();
    };

    //# add listener for icon
    private renderClearCell = (cellNode: HTMLElement, row: any, dataContext: CodeName) =>{
        this.renderer.listen(cellNode[0].querySelector('span'), 'click', ($event) => this.clearDataFilter(dataContext, $event));
    };

    //# render icon for remove
    private formatClearCell = (): string =>{
        return '<span class="fa-solid fa-xmark" data-toggle="tooltip" title="' + this.translates['Remove'] + '" style="cursor: pointer"></span>'
    };

    //# set grid visible
    private setGridTop = (): void =>{
        let $mainWrapper = $(this.mainWrapper.nativeElement.parentElement);
        this.gridTop = $mainWrapper.outerHeight();
    };

    //# remove column from grid
    private removeColumn = (columns: any[]): any[] =>{
        return columns.filter(item => !(this.mainData.type !== 1 && item.id === 'code'));
    };

    //# hide list
    private hideList = (e: MouseEvent): void =>{
        let clickOnList = this.helper.hideList(this.mainWrapper.nativeElement.parentElement, e, this.renderer);
        if (clickOnList){
            this.showGrid = false;
        }
    };

}




// WEBPACK FOOTER //
// ./src/app/stocks/components/selected-filter.component/selected-filter.component.ts